<template>
  <div class="flex flex-col">
    <label class="font-bold text-gray-dark text-xl">Block name</label>
    <span class="font-bold text-black">{{ template && template.name }}</span>

    <div v-if="contextKey" class="mt-8 flex flex-col">
      <span class="text-gray-dark font-bold text-xl">Wait for customer input</span>
      <div class="flex justify-between items-center mt-4">
        <div class="flex">
          <vs-checkbox value=true disabled :color="focusColor" class="ml-0 cursor-not-allowed"/>
          <span class="text-gray-dark">Save input as</span>
        </div>
        <base-input :value="contextKey" disabled class="text-gray-dark cursor-not-allowed"/>
      </div>

      <div class="text-gray-dark mt-4 text-sm">
        You can save customer input in a <strong>context</strong> to access it later on,
        e.g. print what the customer said or to send data to your server.
      </div>

      <wait-for-input-editor-validation v-if="validationParams"
                                        :validation-params="validationParams"
                                        class="mt-4"
                                        :is-disabled="true"

      />
    </div>

    <ChatGPTEditor v-else-if="gptAction"
                   class="mt-8 w-full"
                   :is-disabled="true"
    />

    <div v-else-if="remoteAction" class="mt-8 flex flex-col">
      <span class="text-gray-dark font-bold text-xl">API call</span>
      <div class="flex justify-between items-baseline text-gray-dark mt-2">
        <span class="font-bold">Request Payload</span>
        <span class="text-xs">(read-only)</span>
      </div>
      <json-input class="mt-2" :value="remoteAction" :is-disabled="true"/>
    </div>

    <base-button variant="bordered" class="w-full mt-10" :router-link="getRouteDetails()">
      Edit block
    </base-button>

    <base-button variant="bordered" class="w-full mt-4" :router-link="getRouteDetails(true)">
      View block usages
    </base-button>

    <base-button variant="bordered-error"
                 class="w-full mt-4"
                 @click="removeTemplate"
    >
      Remove block from answer
    </base-button>
  </div>
</template>

<script>
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import conversationModule from '@/store/modules/conversation.module'
import templateModule from '@/store/modules/template.module'
import answerController from '@/controllers/answer.controller'
import ChatGPTEditor from '@/components/editor/ChatGPTEditor'
import WaitForInputEditorValidation from '@/components/editor/WaitForInputEditorValidation'
import tailwind from '../../../tailwind.config'
import { PREVIEW_ITEM } from '@/store/constants'
import { ROUTE_NAMES } from '@/router'
import JsonInput from '@/components/base-components/JsonInput'

export default {
  name: 'TemplateRefEditor',
  components: { ChatGPTEditor, JsonInput, WaitForInputEditorValidation },

  props: {
    botId: {
      type: String,
      required: true
    }
  },

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    stateTree: chatBubbleModule.stateTree,
    templateList: templateModule.templateList,
    conversationJsons: conversationModule.getJsons,

    contextKey() {
      if (this.bubbleSelected.type !== PREVIEW_ITEM.WAIT_FOR_INPUT) return null

      const contextStateRefId = this.bubbleSelected.contextStateId
      if (!contextStateRefId) return null

      return conversationModule.getTemplateState(contextStateRefId).contextKey
    },

    gptAction() {
      if (this.bubbleSelected.type !== PREVIEW_ITEM.CHAT_GPT_BUBBLE) return null

      const action = this.conversationJsons.templates[this.template.id].actions[this.bubbleSelected.actionId]
      return action
    },

    remoteAction() {
      if (this.bubbleSelected.type !== PREVIEW_ITEM.REMOTE_BUBBLE) return null

      const action = this.conversationJsons.templates[this.template.id].actions[this.bubbleSelected.actionId]
      return action
    },

    validationParams() {
      if (!this.bubbleSelected.hasOwnProperty('validationActionId')) return null

      return this.bubbleSelected.validationActionId ?
        conversationModule.getAction(this.bubbleSelected.stateId, this.bubbleSelected.validationActionId)?.params :
        { pattern: 'none' }
    },

    focusColor() {
      return tailwind.theme.colors.focus
    },

    template() {
      const templateId = conversationModule.getTemplateIdByTemplateRef(this.bubbleSelected.stateId)
      return this.templateList?.find(template => template.id === templateId)
    }
  },

  methods: {
    getRouteDetails(showSidebar = false) {
      const routeDetails = {
        name: ROUTE_NAMES.blocks,
        params: {
          botId: this.botId,
          blockId: this.template?.id,
          blockName: this.template?.name
        }
      }
      if (showSidebar) {
        return { ...routeDetails, query: { sidebar: 'usages' } }
      }
      return routeDetails
    },

    removeTemplate() {
      answerController.removeTemplateRef(conversationModule.getRootJson(), this.stateTree, this.bubbleSelected.stateId)
    }
  }
}
</script>
